/*
  Launch pages: product grid behaviour.
  - Every card has its own size radio group. Each radio carries the variant
    ids, price (cents) and product URL for that size, rendered by Liquid, so
    a change only re-points that card's button and links, and sets
    data-launch-size on the card so CSS can show a per-size image.
  - Bundle radios carry the comma separated ids of every product card's item
    in that size; launch-cart.js adds them in one /cart/add.js call.
  - Hover/focus films play only on hover-capable pointers and never when the
    visitor prefers reduced motion.
*/
(function () {
  if (window.__launchGridLoaded) return;
  window.__launchGridLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  function money(cents) {
    return window.LaunchCart ? window.LaunchCart.formatMoney(cents) : '$' + Math.round(cents / 100);
  }

  function apply(section, card, input) {
    var isBundle = card.hasAttribute('data-launch-bundle');
    var addText = isBundle
      ? section.getAttribute('data-bundle-add-text') || 'Add to cart'
      : section.getAttribute('data-add-text') || 'Add to cart';
    var unavailable = section.getAttribute('data-unavailable-text') || 'Sold out';
    var ids = input.getAttribute('data-variant-ids') || '';
    var price = Number(input.getAttribute('data-price') || 0);
    var url = input.getAttribute('data-url');
    card.setAttribute('data-launch-size', input.value);

    var btn = card.querySelector('[data-launch-add]');
    if (btn) {
      var label = btn.querySelector('[data-launch-add-label]');
      var status = document.getElementById(btn.getAttribute('aria-describedby') || '');
      if (status) { status.textContent = ''; status.classList.remove('is-error'); }
      if (ids) {
        btn.disabled = false;
        btn.setAttribute('data-variant-ids', ids);
        if (label) label.textContent = addText + ' · ' + money(price);
      } else {
        btn.disabled = true;
        btn.setAttribute('data-variant-ids', '');
        if (label) label.textContent = unavailable;
      }
    }
    if (url) {
      card.querySelectorAll('[data-launch-link]').forEach(function (a) { a.setAttribute('href', url); });
    }
  }

  function initFilms(section) {
    section.querySelectorAll('[data-launch-film-host]').forEach(function (host) {
      var video = host.querySelector('video[data-launch-film]');
      if (!video) return;
      function play() {
        if (reduceMotion.matches || !canHover.matches) return;
        var p = video.play();
        host.classList.add('is-playing');
        if (p && p.catch) p.catch(function () { host.classList.remove('is-playing'); });
      }
      function stop() {
        host.classList.remove('is-playing');
        video.pause();
        try { video.currentTime = 0; } catch (e) {}
      }
      host.addEventListener('mouseenter', play);
      host.addEventListener('mouseleave', stop);
      host.addEventListener('focusin', play);
      host.addEventListener('focusout', function (e) {
        if (!host.contains(e.relatedTarget)) stop();
      });
    });
    if (reduceMotion.addEventListener) {
      reduceMotion.addEventListener('change', function () {
        if (!reduceMotion.matches) return;
        section.querySelectorAll('video[data-launch-film]').forEach(function (v) { v.pause(); });
        section.querySelectorAll('.is-playing').forEach(function (el) { el.classList.remove('is-playing'); });
      });
    }
  }

  function init(section) {
    if (section._launchInit) return;
    section._launchInit = true;
    section.querySelectorAll('[data-launch-card]').forEach(function (card) {
      var inputs = card.querySelectorAll('input[data-launch-size-input]');
      inputs.forEach(function (input) {
        input.addEventListener('change', function () {
          if (input.checked) apply(section, card, input);
        });
      });
      var checked = card.querySelector('input[data-launch-size-input]:checked');
      if (checked) apply(section, card, checked);
    });
    initFilms(section);
  }

  function initAll() {
    document.querySelectorAll('[data-launch-grid]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-launch-grid]');
    if (s) init(s);
  });
})();
